import React from 'react';

export const Help = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-6">Help</h2>
      <p className="text-gray-600">Find answers to your questions and get support.</p>
      <ul className="mt-4 list-disc pl-5">
        <li>How to reset my password?</li>
        <li>How to contact support?</li>
        <li>How to update my account details?</li>
      </ul>
    </div>
  );
};